import { wait } from "@repo/lib/wait";
import { apiService } from "./apiService";

export const meetingService = {
  async publishMeeting({
    tenantId,
    meetingId,
    sendEmails,
  }: {
    tenantId: string;
    meetingId: string;
    sendEmails?: boolean;
  }) {
    try {
      // We need to wait until the meeting is copied to the publicTenants location.
      // Probably the best way for this would be to have an onWrite for the published meeting that handles PDF creation
      await wait(5000);

      const reply = (await apiService.v1.publishMeeting(tenantId, meetingId))
        .data;

      if (sendEmails) {
        console.log(await apiService.v1.mailMeetingPdf(tenantId, meetingId));
      }

      if (reply.errors.length) {
        return reply.errors.join("\n\n");
      }
    } catch (e) {
      console.warn(e);
    }
    return null;
  },

  async sendMeetingToLaserfiche({
    tenantId,
    meetingId,
  }: {
    tenantId: string;
    meetingId: string;
  }) {
    try {
      const reply = (await apiService.v1.sendToLaserfiche(tenantId, meetingId))
        .data;

      if (reply.errors.length) {
        return reply.errors.join("\n\n");
      }
    } catch (e) {
      console.warn(e);
    }
    return null;
  },
};
